import { MarkSpec } from 'prosemirror-model'

// from prosemirror-schema-basic

export const highlight: MarkSpec = {
  parseDOM: [{ tag: 'mark' }],
  toDOM: () => ['mark', 0],
}
